import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionsetsLayoutComponent } from './overview/layout/permissionsets-layout.component';
import { PermissionsetsOverviewComponent } from './overview/overview/permissionsets-overview.component';
import { PermissionsetsSidepanelComponent } from './overview/sidepanel/permissionsets-sidepanel.component';
import { PermissionsetsNavigatorHelper } from './permissionsets-navigator-helper';
import { PermissionsetFacade } from '../shared/services/facades/permissionset.facade';
import { PermissionsetService } from '../shared/services/permissionset.service';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PermissionsetDetailsComponent } from 'app/permissionsets/detail/permissionset-details.component';
import { PermissionsetDetailsGeneralComponent } from 'app/permissionsets/detail/permissionset-details-general.component';
import { PermissionsetEntityResolver } from 'app/shared/components/entity-resolvers/permissionset.entity-resolver';
import { PermissionsetDetailsPermissionsComponent } from 'app/permissionsets/detail/permissionset-details-permissions.component';
import { PermissionService } from 'app/shared/services/permission.service';
import { PermissionsetsRoutingModule } from './permissionsets-routes.module';
import { PermissionsetsImportWizardComponent } from './overview/overview/permissionsets-import-wizard.component';
import { TreeModule } from 'primeng/tree';
import { DropdownModule } from 'primeng/dropdown';
import { PermissionsetWizardImportComponent } from './detail/permissionset-details-wizard-import.component';
import { PermissionsetWizardCopyComponent } from './detail/permissionset-details-wizard-copy.component';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [
    PermissionsetsLayoutComponent,
    PermissionsetsOverviewComponent,
    PermissionsetsSidepanelComponent,
    PermissionsetDetailsComponent,
    PermissionsetDetailsGeneralComponent,
    PermissionsetDetailsPermissionsComponent,
    PermissionsetsImportWizardComponent,
    PermissionsetWizardImportComponent,
    PermissionsetWizardCopyComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TableModule,
    PermissionsetsRoutingModule,
    SelectButtonModule,
    TreeModule,
    DropdownModule,
    TooltipModule,
  ],
  exports: [
    PermissionsetsLayoutComponent,
    PermissionsetsOverviewComponent,
    PermissionsetsSidepanelComponent,
    PermissionsetDetailsComponent,
    PermissionsetDetailsGeneralComponent,
  ],
  providers: [
    PermissionsetFacade,
    PermissionsetService,
    PermissionService,
    PermissionsetsNavigatorHelper,
    PermissionsetEntityResolver,
    PermissionsetDetailsPermissionsComponent,
  ],
})
export class PermissionsetsModule {}
